import type { PropsWithChildren, ReactElement } from "react";

import { getPackagesPageHref } from "app/UtilitiesAndConstants/UtilityFunctions/goToPackagesPage";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import { type UpgradeCellHookParams, useUpgradeCellHook } from "../hooks/useUpgradeCellHook";

export type UpgradeCellContainerProps = {
    isUpgradeVisible: boolean;
    upgradeText?: string;
} & UpgradeCellHookParams;

export const UpgradeCellContainer = ({
    isUpgradeVisible,
    upgradeText,
    children,
    ...hookParams
}: PropsWithChildren<UpgradeCellContainerProps>): ReactElement => {
    const translate = useTranslation();

    const { triggerUpgradeAction, renderUpgradeView: UpgradeView } = useUpgradeCellHook(hookParams);

    if (isUpgradeVisible) {
        // Safely get packageUrl from requestOptions if it exists
        const packageUrl = hookParams.requestOptions?.packageUrl || getPackagesPageHref();

        return (
            <UpgradeView
                onClick={triggerUpgradeAction}
                packageUrl={packageUrl}
            >
                {upgradeText ?? translate("grid.upgrade")}
            </UpgradeView>
        );
    }

    return <>{children}</>;
};
